// Import dependencies
import React from 'react';

// Import components
import LogoutButton from '../logout';


class AdminNavbar extends React.Component {
    render() {
        return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light rounded shadow-sm">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div className="navbar-nav">
                    <a className="nav-item nav-link" href="/admin/history">Login history</a>
                    <a className="nav-item nav-link" href="/admin/members">Members</a>
                    <a className="nav-item nav-link" href="/videos">Videos</a>
                    <a className="nav-item nav-link" href="/admin/affiliate">Affiliate Management</a>
                    <a className="nav-item nav-link" href="/admin/special">Special Access</a>
                    <div className="dropdown" >
                        <a className="nav-item nav-link" href="#" id="dropdownMenuLink" data-toggle="dropdown" aria-expanded="false" aria-controls="dropdownMenuMarkup">
                            Analytics &#x25BF;
                        </a>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuLink" id="dropdownMenuMarkup">
                            <a className="dropdown-item" href="/admin/analytics/videos">Videos</a>
                            <a className="dropdown-item" href="/admin/analytics/livestream">Livestream</a>
                        </div>
                    </div>
                    <a className="nav-item nav-link" href="/admin/settings">Settings</a>
                </div>
            </div>
            <LogoutButton />
        </nav>
        
        )
    }
}

export default AdminNavbar;